import React, { useEffect, useState } from 'react';
// Hooks
import { useBreakpoints } from 'hooks';
// Types
import { SearchStores_stores_entities } from 'api/store/types/SearchStores';
// Ui
import Carousel from 'ui/Carousel/Carousel';
// Components
import TagStoresListItem from '../TagStoresListItem/TagStoresListItem';

import styles from './TagStoresList.module.scss';

type TagStoresListProps = {
  stores: SearchStores_stores_entities[];
  withCarousel?: boolean;
};

const TagStoresList: React.FC<TagStoresListProps> = ({
  stores,
  withCarousel,
}) => {
  const { isBreakpointM } = useBreakpoints();
  const [showCarousel, setShowCarousel] = useState<boolean>(false);

  useEffect(() => {
    if (isBreakpointM) {
      setShowCarousel(false);
    } else if (!isBreakpointM && withCarousel) {
      setShowCarousel(true);
    }
  }, [isBreakpointM, withCarousel]);

  if (!stores?.length) {
    return null;
  }

  return !showCarousel ? (
    <ul className={styles.tagStoresList}>
      {stores.map((store) => (
        <li className={styles.tagStoresListItem} key={store.id}>
          <TagStoresListItem store={store} />
        </li>
      ))}
    </ul>
  ) : (
    <Carousel>
      {stores.map((store) => (
        <TagStoresListItem key={store.id} store={store} />
      ))}
    </Carousel>
  );
};

export default TagStoresList;
